import App3 from "./FlipCard";
import './Event.css';
import cyber from './img/cyber_hunter.jpeg';
import beatstorm from './img/Beat_storm.jpeg';
import anveshan from './img/Anvesham.jpeg';
import sujal from './img/naam_sujal.jpg';
import irfan from './img/irfan.jpg';
import auto_expo from './img/auto_expo.jpeg';
import robo_soccer from './img/robo_soccer.jpeg';
import safar_music from './img_sc/safar_music.jpeg';
import project_x from './img/project_x.jpeg';
import innovatex from './img/innovatex.jpeg';
import prompt_heist from './img/prompt_heist.jpeg';
import eco_quest from './img/eco_quest.jpeg';
import robaroo from './img/roobaroo.jpeg';
import dj_night from './img/dj_night.jpeg';
import gig_a_night from './img/gig_a_night.jpeg';
import innofest from './img/innofest.jpeg';
import final_ark from './img/final_ark.jpeg';



function App() {
  return (
    <>
      <h1 className="events-heading">EVENTS</h1>
      <div className="flip-container">
        <div className="flip-row">
          <App3 imgsrc={beatstorm} front="BEAT STORM" organiser="ROBAROO" date="16 Jan"  time="1:15pm-1:30pm" place="Department Circle" />
          <App3 imgsrc={anveshan} front="ANVESHAN-TREASURE HUNT" organiser="ROBOTICS CLUb" date="23-25Jan" time="all day"place="LRC"/>
          <App3 imgsrc={cyber} front="CYBER HUNTER 2.0" organiser="OSWAP" date="22 -23 Jan" time="All day" place="LRC" />
          <App3 imgsrc={robo_soccer} front="ROBO_SOCCER" organiser="ROBOTICS CLUB" date="23 Jan" time="2 PM" place="LRC" />
          <App3 imgsrc={project_x} front="PROJECT_X" organiser="VISION" date="23 -24 Jan" time="2 PM" place="LRC" />
          <App3 imgsrc={innovatex} front="INNOVATEX" organiser="ROBOTICS CLUB" date="23 Jan" time="to be annonced soon" place="to be disclosed soon" />
          <App3 imgsrc={prompt_heist} front="PROMPT HEIST" organiser="VISION" date="23 -24Jan" time="10 AM" place="LRC" />
          <App3 imgsrc={eco_quest} front="ECO QUEST{series of game}" organiser="PURGE" date="25 Jan" time="10AM- 5PM" place="LRC" />
          <App3 imgsrc={final_ark} front="THE FINAL ARK" organiser="4ARKS" date="23-24 Jan" time="10AM-4PM" place="LRC" />
          <App3 imgsrc={auto_expo} front="AUTO EXPO 2.0" organiser="SAE" date="24 Jan" time="3-6.30 PM" place="Manit porch" />
          <App3 imgsrc={gig_a_night} front="ROBAROO" organiser="ROBAROO" date="22 Jan" time="6:30PM-9 PM" place="LRC STAGE" />
          <App3 imgsrc={innofest} front="INNOFEST 3.0" organiser="THINK INDIA MANIT CHAPTER" date="22 Jan" time="2 PM" place="MME AUDI" />
          <App3 imgsrc={dj_night} front="DJ NIGHT" organiser="STUDENT COUNCIL" date="23 Jan" time="6.30PM- 9.30 PM" place="LRC STAGE" />
          <App3 imgsrc={sujal} front="NAAM SUJAL" organiser="STUDENT COUNCIL" date="24 Jan" time="8 PM" place="LRC" />
          <App3 imgsrc={irfan} front="MOHAMMED IRFAN" organiser="STUDENT COUNCIL" date="25 Jan" time="7 PM" place="LRC" />
          <App3 imgsrc={safar_music} front="SAFAR MUSIC" organiser="STUDENT COUNCIL" date="24 Jan" time="6:30 PM-8 PM" place="LRC" />
        </div>
      </div>
    </>
  );
}

export default App;
